import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

function InstalledSection({onChange, selectedLocation}) {
  return (
    <DesktopDatePicker
      label="Installation Date"
      inputFormat="MM/DD/YYYY"
      value={selectedLocation.installationDate || null}
      onChange={(date) => {
        onChange({ target: { name: 'installationDate', value: date } });
      }}
      renderInput={(params) => <TextField {...params} />}
    />
  );
}

InstalledSection.propTypes = {
  selectedLocation: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InstalledSection;